class MyCraftSpiritsGiftAddToCart {
  constructor(blockElement) {
    this.blockElement = blockElement;
    this.addToCartButton = blockElement.querySelector('.add-to-cart-button');
    this.cartForm = blockElement.querySelector('.cart-form');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.validationContainer = blockElement.querySelector('.validation-messages');
    this.priceElements = {
      base: blockElement.querySelector('[data-base-price]'),
      extras: blockElement.querySelector('[data-extras-price]'),
      total: blockElement.querySelector('[data-total-price]')
    };

    this.startVariant = JSON.parse(blockElement.dataset.product);

    this.inputs = {
      recipient_name: null,
      message: null,
    };

    this.selections = {
      bottleCount: this.startVariant.option1 || null,
    };

    this.prices = {
      base: parseInt(this.priceElements.base.dataset.basePrice) || 0,
      current: parseInt(this.priceElements.base.dataset.basePrice) || 0
    };

    this.init();
  }

  init() {
    this.addEventListeners();
    this.handleVariantChange(this.startVariant);
    this.validateSelections();
  }
  
  addEventListeners() {
    document.addEventListener('input-changed', (e) => {
      this.updateInputs(e.detail.input);
      this.validateSelections();
    });

    document.addEventListener('variant:change', (e) => {
      this.handleVariantChange(e.detail.variant);
    });

    document.addEventListener('size-changed', (e) => {
      this.selections.bottleCount = e.detail.value;
      this.updatePricing();
    });

    this.addToCartButton.addEventListener('click', () => {
      this.addToCart();
    });
  }

  updateInputs(input) {
    const field = input.name.replaceAll('properties[', '').replaceAll(']', '');
    this.inputs[field] = input.value;
  }

  handleVariantChange(variant) {
    if (!variant) return;

    // Extract options from variant
    this.selections.bottleCount = this.extractVariantOption(variant, 'Bottle Count');

    // Update pricing based on variant
    this.prices.current = variant.price || 0;

    // Update the form variant ID
    const variantIdInput = this.cartForm.querySelector('[name="id"]');
    if (variantIdInput) {
      variantIdInput.value = variant.id;
    }

    this.updatePricing();
    this.validateSelections();
  }

  extractVariantOption(variant, optionName) {
    // Try to find the option by matching with variant options
    if (variant.options) {
      const optionIndex = variant.product?.options?.findIndex(opt => opt.name === optionName);
      if (optionIndex !== -1 && variant.options[optionIndex]) {
        return variant.options[optionIndex];
      }
    }

    // Fallback: try to extract from variant title
    if (variant.title && variant.title.includes('/')) {
      const options = variant.title.split(' / ');
      // This is a simple fallback - you may need to adjust based on your variant title structure
      return options.find(opt => opt.includes(optionName.split(' ')[0]));
    }

    return null;
  }

  validateSelections() {
    const validations = [];

    if (!this.inputs.recipient_name) {
      validations.push('recipient_name');
    }

    if (!this.inputs.message) {
      validations.push('message');
    }

    this.updateValidationDisplay(validations);

    const isValid = validations.length === 0;
    this.addToCartButton.disabled = !isValid;

    return isValid;
  }

  updateValidationDisplay(validations) {
    const validationMessages = this.blockElement.querySelectorAll('.validation-message');

    // Hide all validation messages first
    validationMessages.forEach(msg => {
      msg.style.display = 'none';
    });

    // Show container if there are validations
    if (validations.length > 0) {
      this.validationContainer.style.display = 'block';

      // Show specific validation messages
      validations.forEach(validation => {
        const msg = this.blockElement.querySelector(`[data-validation="${validation}"]`);
        if (msg) {
          msg.style.display = 'flex';
        }
      });
    } else {
      this.validationContainer.style.display = 'none';
    }
  }

  updatePricing() {
    // The variant price includes all options, so we use that as the total
    const total = this.prices.current;
    const extrasCost = this.prices.current - this.prices.base;

    // Update DOM
    this.priceElements.extras.textContent = this.formatPrice(extrasCost);
    this.priceElements.extras.parentElement.style.display = extrasCost > 0 ? 'flex' : 'none';

    this.priceElements.total.textContent = this.formatPrice(total);
    this.priceElements.total.dataset.totalPrice = total;
  }

  formatPrice(priceInCents) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(priceInCents / 100);
  }

  async addToCart() {
    if (!this.validateSelections()) return;

    this.setLoading(true);

    try {
      const formData = this.buildFormData();

      const craftSpiritCheckout = new CraftSpiritCheckout(this, formData);
      await craftSpiritCheckout.addToCart();
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Sorry, there was an error adding this item to your cart. Please try again.');
    } finally {
      this.setLoading(false);
    }
  }

  buildFormData() {
    const formData = new FormData(this.cartForm);

    formData.append('properties[recipient_name]', this.inputs.recipient_name || "");
    formData.append('properties[message]', this.inputs.message || "");

    return formData;
  }

  setLoading(loading) {
    const buttonText = this.addToCartButton.querySelector('.button-text');
    const spinner = this.addToCartButton.querySelector('.loading-spinner');

    if (loading) {
      buttonText.style.display = 'none';
      spinner.style.display = 'block';
      this.addToCartButton.disabled = true;
    } else {
      buttonText.style.display = 'block';
      spinner.style.display = 'none';
      this.addToCartButton.disabled = !this.validateSelections();
    }
  }

  async refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Dispatch cart updated event
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));
      return cart;
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
    return null;
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const addToCartBlocks = document.querySelectorAll('.my-craft-spirits-gift-add-to-cart-block');

  addToCartBlocks.forEach(block => {
    new MyCraftSpiritsGiftAddToCart(block);
  });
});
